import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("sc_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const money = (n: number) =>
  `A$${Number(n || 0).toLocaleString("en-AU", { maximumFractionDigits: n % 1 ? 2 : 0, minimumFractionDigits: n % 1 ? 2 : 0 })}`;

export const monthly = (n: number, months = 36) => Math.ceil(n / months);

export function errMsg(e: any): string {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const METAL_SWATCH: Record<string, string> = {
  Platinum: "#E5E4E2",
  "18K White Gold": "#F0EFEA",
  "18K Yellow Gold": "#E3C77A",
  "18K Rose Gold": "#E8B6A0",
  "Sterling Silver": "#D9D9D9",
};
